import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=53f0df98&scoped=true"
import script from "./Example.vue?vue&type=script&lang=js"
export * from "./Example.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0df98",
  null
  
)

export default component.exports